module.exports = "/src/views/player/help/images/waxta.jpg";